<template>
    <main>
        <div class="container-fluid">
            <div class="row">
                <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                    </div>
                    <div class="page-toolbar">
                        <div class="page-title"><span class="title">Create User Dashlet</span> 
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <GenericNew v-if="generic" ref="loadGeneric" :urls="urls"></GenericNew>
        <CustomNew v-else></CustomNew>

    </main>
</template>

<script>
    import { ref } from "vue";
    import breadcrumbs from "@/views/modules/UserDashlets/MenuList.vue";
    import lang from "@/views/modules/UserDashlets/language/en";
    import GenericNew from "@/components/layout/shared/generic/NewView.vue";
    import CustomNew from "@/views/modules/UserDashlets/NewView.vue";

    export default {
        name: "add-userdashlet",
        components: {
            breadcrumbs,
            GenericNew,
            CustomNew,
        },
        data() {
            return {
                generic: false,
                metaList: [

                    {
                        type: 'text',
                        name: 'name',
                        label: 'Taxtype Name',
                        required: true
                    },
                    {
                        type: 'text',
                        name: 'tax',
                        label: 'Tax Rate',
                        required: true
                    },
                    {
                        type: 'selectbox',
                        name: 'status',
                        label: 'Status',
                        items: [
                            { value: 'Active' },
                            { value: 'Inactive' },
                        ],
                        required: true
                    },
                    {
                        type: 'textarea',
                        name: 'description',
                        label: 'Description',
                        required: false
                    },
                ],
                urls: 'api/modules/taxtypes',

                routePath: {
                    path: 'taxtypes',
                    detail: false
                }

            }
        },
        mounted() {
            this.childMethod()
        },
        methods: {
            childMethod() {
                if (this.generic == true) {
                    this.$refs.loadGeneric.loadGenericView(this.metaList, this.routePath);
                }
            }
        },
    }
</script>